import { render, staticRenderFns } from "./WaitingMessage.vue?vue&type=template&id=357edc1a&scoped=true"
import script from "./WaitingMessage.vue?vue&type=script&lang=js"
export * from "./WaitingMessage.vue?vue&type=script&lang=js"
import style0 from "./WaitingMessage.vue?vue&type=style&index=0&id=357edc1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357edc1a",
  null
  
)

export default component.exports